import { Box, styled, ToggleButton } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  height: theme.spacing(8),
  padding: theme.spacing(1.8),
  [theme.breakpoints.down('xs')]: {
    padding: theme.spacing(1),
  },
  img: {
    width: '100%',
    height: '100%',
  },
  '&:hover': {
    background: 'none',
    img: {
      filter: 'brightness(100%) contrast(1000%)',
    },
  },
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: theme.palette.grey[50],
    img: {
      filter: 'brightness(0%) contrast(100%)',
    },
  },
}));
